import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const CUSTOMER_FILE_SUBMISSION = "CUSTOMER_FILE_SUBMISSION";
export const CUSTOMER_FILE_SUBMISSION_LOADING =
"CUSTOMER_FILE_SUBMISSION_LOADING";
export const CUSTOMER_FILE_SUBMISSION_LOADING_FAILED =
"CUSTOMER_FILE_SUBMISSION_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const customerFileSubmissionLoading = ms => ({
    type: CUSTOMER_FILE_SUBMISSION_LOADING,
    payload: ms
    });
    
    export const customerFileSubmissionLoadingFailed = ms => ({
    type: CUSTOMER_FILE_SUBMISSION_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function customerFileSubmission(obj) {
 /*    for (var value of obj.values()) {
        console.log(value,"ghghhg"); 
     } */
    const request = axios.post(
    `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/files/openFile`,obj, {
        headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
      });
    return dispatch => {

    dispatch(customerFileSubmissionLoading());
    request
    .then(response => {   
  
    if (response.status == 201) {
    /*  console.log(response,"response customerFileSubmission") */
    dispatch({
    type: CUSTOMER_FILE_SUBMISSION,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        customerFileSubmissionLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(customerFileSubmissionLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(customerFileSubmissionLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(customerFileSubmissionLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


